import { aclFeatures } from '@/lib/acl/aclFeatures';
// Types
import type { RoleType } from '@/lib/user/roles';
// Libs
import { ADMIN_ROLE, MANAGER_ROLE } from '@/lib/user/roles';

import { Trans } from '@/components/tools/translation';

// Routes
import {
    ACCOUNT,
    DATA_ACCESS,
    INTEGRATIONS,
    PLATFORM_OPTIONS,
    SECURITY,
    SUBSCRIPTION_INVOICES,
    THEMES,
    USERS_ROLES
} from '@/routes/privateRoutes';

export type SettingsSubMenuEntryType = {
    id: string;
    icon: string;
    name: string;
    title?: string;
    link: string;
    target_blank?: boolean;
    acl?: {
        permissions_to_hide?: string[];
        roles?: RoleType[];
    };
};

export type SettingsMenuEntryType = {
    id: string;
    name: React.ReactNode;
    subMenuItems: SettingsSubMenuEntryType[];
};

export const settingsMenu: SettingsMenuEntryType[] = [
    {
        id: 'settings',
        name: <Trans i18nKey="commons:menu.settings" />,
        subMenuItems: [
            {
                id: 'informations',
                icon: 'wow-reaction',
                name: 'commons:menu.information',
                title: 'settings:informations',
                link: ACCOUNT
            },
            {
                id: 'users_and_roles',
                icon: 'users-roles',
                name: 'commons:menu.users_roles',
                title: 'settings:users_and_roles',
                link: USERS_ROLES,
                acl: {
                    roles: [ADMIN_ROLE, MANAGER_ROLE]
                }
            },
            {
                id: 'subscription_and_invoices',
                icon: 'paid-data',
                name: 'commons:menu.subscription_invoices',
                title: 'settings:subscription_invoices',
                link: SUBSCRIPTION_INVOICES,
                acl: {
                    roles: [ADMIN_ROLE]
                }
            },
            {
                id: 'platform',
                icon: 'filter',
                name: 'commons:menu.platform',
                title: 'settings:platform',
                link: PLATFORM_OPTIONS
            },
            {
                id: 'data_access',
                icon: 'link',
                name: 'commons:menu.data_access',
                title: 'settings:data_access',
                link: DATA_ACCESS,
                acl: { permissions_to_hide: [aclFeatures.account.data_access.read] }
            },
            {
                id: 'security',
                icon: 'locked',
                name: 'commons:menu.security',
                title: 'settings:security_page.change_password',
                link: SECURITY
            },
            {
                id: 'integrations',
                icon: 'widgets',
                name: 'commons:menu.integrations',
                title: 'settings:generate_integration',
                link: INTEGRATIONS,
                acl: {
                    roles: [ADMIN_ROLE]
                }
            },
            {
                id: 'appearance',
                icon: 'sparkles',
                name: 'commons:menu.appearance',
                title: 'settings:themes_page.heading',
                link: THEMES
            }
        ]
    },
    {
        id: 'iconosquare',
        name: 'iconosquare',
        subMenuItems: [
            {
                id: 'product-updates',
                icon: 'product-updates',
                name: 'commons:menu.product_updates',
                link: 'https://www.iconosquare.com{lang}product-updates',
                target_blank: true
            },
            {
                id: 'help_center',
                icon: 'help',
                name: 'commons:menu.help_center',
                link: 'https://support.iconosquare.com',
                target_blank: true
            }
        ]
    }
];
